<template>
    <div class="grid grid-cols-1 min-[650px]:grid-cols-2 min-[1150px]:grid-cols-4 gap-2 max-w-[1145px] px-[15px] w-full mx-auto">
        <div
            class="bg-[url(@/../img/bg/apply-bg.png)] bg-cover bg-no-repeat rounded-[15px] border border-[#eeeff2] overflow-hidden"
        >
            <div class="px-6 pt-[1.2em] pb-[1.2em]">
                <p
                    class="text-[18px] font-[500] mb-2"
                >Apply for Listing</p>
                <a
                    href="https://forms.gle/bT66JeqjTPBXsUiE7"
                    target="_blank"
                    class="block border !border-[#366fed] rounded-[10px] w-fit text-base font-[500] text-[#366fed] px-3 py-2"
                >
                    Apply Now
                </a>
            </div>
            <a
                href="#"
                class="text-[12px] font-[500] text-center block bg-[#dce7ff] py-1 px-1"
            >
                Get custom solution for your growth! >
            </a>

        </div>
        <div
            class="bg-white rounded-[15px] px-6 pt-[1.7em] pb-[1.4em]"
            :class="{ 'border border-[#eeeff2]': showBorder === true }"
            v-for="(featuredMarket, i) in featuredMarkets.slice(0, 3)"
            :key="featuredMarket.id || i"
        >
            <div class="flex items-start justify-between gap-2">
                <div class="flex items-center justify-center w-[42px] h-[42px] rounded-full bg-white border-2 border-gray-200 flex-shrink-0">
                    <img
                        alt="currency-logo"
                        :src="currencyIcons[`../../../../public/img/coins/${featuredMarket.market.from_cgw_currency.slug.toLowerCase()}.svg`]?.default"
                    >
                </div>
                <div class="mt-[6px]">
                    <span class="block text-[18px] font-[CircularBook] tracking-wide">{{ featuredMarket.market.from_cgw_currency.name }}</span>
                    <span class="block text-[12px] text-[#a4a6aa] font-[CircularBook] tracking-wide">{{featuredMarket.market.from_cgw_currency.slug}}</span>
                </div>
                <div class="flex-1 flex justify-end mt-[9px]">
                    <span
                        class="block text-white text-[12px] font-[600] bg-[#58bd7d] rounded-[5px] px-[.38em] py-[.25em] w-fit font-[CircularMedium]"
                        :class="featuredMarket.change_day >= 0 ? 'bg-[#58bd7d]' : 'bg-[#cf3d3d]'"
                    >
                        {{ featuredMarket.change_day }}%
                    </span>
                </div>
            </div>
            <div class="ml-[50px] mt-2">
                <span class="block text-[22px] font-[CircularBook] tracking-wide" :title="parseFloat(featuredMarket.quote_volume_day).toFixed(featuredMarket.market.total_decimals) + ' ' + featuredMarket.market.to_cgw_currency.slug">
                    {{ parseFloat(featuredMarket.volume_day).toFixed(featuredMarket.market.total_decimals) }} {{ featuredMarket.market.from_cgw_currency.slug }}
                </span>
            </div>
        </div>
    </div>
</template>
<script setup>
import { onMounted, ref } from "vue";
import {backendSocket} from "../../sockets";
const currencyIcons = import.meta.glob("../../../../public/img/coins/*.svg",{ eager: true })
const featuredMarkets = ref(window.featuredMarkets);
const props = defineProps({
    showBorder: {
        type: Boolean,
        default: false,
    }
});
onMounted(() => {
    backendSocket.channel('market.public').listen('.market_data.updated', ({marketData}) => {
        const foundIndex = featuredMarkets.value.findIndex((el, index) => el.id === marketData.id)

        const newFeaturedMarket = featuredMarkets.value;
        newFeaturedMarket[foundIndex] = marketData

        featuredMarkets.value = newFeaturedMarket;
    });


    window.addEventListener("resize", ()=>maxWidth.value = window.matchMedia("(max-width: 1280px)"));
})

let maxWidth = ref(window.matchMedia("(max-width: 1280px)"));
</script>
